import React from "react"
import { FormControl, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { MUIDatePicker } from "../dateTimePicker/datePicker"
import { useTranslation } from "react-i18next"
import localizationKeys from "../../i18n/localizationKeys"

const styles = {
  durationPicker: {
    display: "flex",
    justifyContent: "center",
  },
  rightLabel: {
    display: "flex",
    justifyContent: "center",
    color: "#19b2ab",
    marginBottom: "4px",
  },
}

export const EmissionDurationPicker = ({startDate, setStartDate, endDate, setEndDate}) => {
  const {t} = useTranslation();
  return (
    <FormControl sx={styles.durationPicker}>
    <Typography sx={styles.rightLabel}>
      {t(localizationKeys.EmissionDataDuration)}
    </Typography>
    <Box sx={{width: '100%'}}>
      <Typography color="white" fontSize={12}>{t(localizationKeys.StartTime)}</Typography>
      <MUIDatePicker date={startDate} setDateFunction={(d) => setStartDate(d)} isStart={true} limitationDate={endDate}/>
      <Typography color="white" fontSize={12}>{t(localizationKeys.EndTime)}</Typography>
      <MUIDatePicker date={endDate} setDateFunction={(d) => setEndDate(d)} isStart={false} limitationDate={startDate}/>
    </Box>
  </FormControl>
  )

}